import type { ApiResponseType, PaginatedResponseType } from '~/types/api'
import api, { apiData } from './api'

export interface LeadType {
  id: number
  /** null = llegó sin empresa asignada (el dominio de la visita no resolvió). */
  companyId: string | null
  name: string
  email?: string | null
  phone?: string | null
  interest?: string | null
  message?: string | null
  source?: string | null
  status?: number | null
  createdAt?: string | null
  /** Cliente creado a partir de este prospecto; null mientras no se convierta. */
  customerId?: number | null
  convertedAt?: string | null
}

export const leadService = {
  async list(params?: { page?: number; limit?: number }) {
    return apiData(api.get<ApiResponseType<PaginatedResponseType<LeadType>>>('/leads', { params }))
  },

  async delete(id: number) {
    return apiData(api.delete<ApiResponseType<boolean>>(`/leads/${id}`))
  },

  /** Elimina varios prospectos de una vez. Devuelve cuántos se borraron. */
  async bulkDelete(ids: number[]) {
    return apiData(api.post<ApiResponseType<{ deleted: number }>>('/leads/bulk-delete', { ids }))
  },

  /**
   * Adopta un prospecto sin empresa (companyId null). Por defecto va a la
   * empresa activa; un usuario root puede pasar `companyId` para elegir destino.
   */
  async assign(id: number, companyId?: string) {
    return apiData(api.post<ApiResponseType<LeadType>>(`/leads/${id}/assign`, companyId ? { companyId } : {}))
  },

  /**
   * Crea la ficha de cliente a partir del prospecto y lo marca como convertido.
   * Es lo que ocurre al arrastrar su tarjeta fuera de la primera columna.
   */
  async convert(id: number, estadoCliente?: string) {
    return apiData(api.post<ApiResponseType<{ id: number; name: string }>>(`/leads/${id}/convert`, estadoCliente ? { estadoCliente } : {}))
  }
}
